module.exports = __webpack_public_path__ + "assets/ec53ffce113c891d7f0b45d0a5f87bc8.png";